import React from 'react'

const UserIcon = ({ className = '', stroke = 'currentColor', ...props }) => {
  return (
    <svg
      width="20"
      height="22"
      viewBox="0 0 20 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`${className}`}
      {...props}
    >
      <path
        d="M7 12H15M7 12V17C7 18.886 7 19.828 7.586 20.414C8.172 21 9.114 21 11 21C12.886 21 13.828 21 14.414 20.414C15 19.828 15 18.886 15 17V12M7 12C5.64789 11.6994 4.40617 11.0283 3.41392 10.0618C2.42168 9.09535 1.71811 7.87173 1.382 6.528L1 5M15 12C16.71 12 18.15 13.28 18.35 14.98L19 20.5"
        stroke={stroke}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M11 9C13.2091 9 15 7.20914 15 5C15 2.79086 13.2091 1 11 1C8.79086 1 7 2.79086 7 5C7 7.20914 8.79086 9 11 9Z"
        stroke={stroke}
        strokeWidth="1.5"
      />
    </svg>
  )
}

export default UserIcon